<div class="table">
    <p-table #tt [value]="usersTable" [paginator]="true" [rows]="numberOfRows" resetPageOnSort="true" [pageLinks]="3"
        [rowsPerPageOptions]="[10,20,30,50,100]" [resizableColumns]="true" [autoLayout]="true"
        [globalFilterFields]="['userId','name','email','username','userActive','customerActive','platform','platformVersion','applicationVersion']">
        <ng-template pTemplate="caption">
            <p-selectButton [ngStyle]="{'float': 'left'}" [(ngModel)]="userStatus"
                [options]="[{label: 'Todos', value: null}, {label: 'Ativo', value: true}, {label: 'Inativo', value: false}]"
                (onChange)="filterByStatus($event.value)">
            </p-selectButton>
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input type="text" pInputText size="50" placeholder="Filtro global"
                    (input)="tt.filterGlobal($event.target.value, 'contains')" style="width:auto">
            </span>
            <span style="font-weight: bold; float: right; margin-top: 5px;">{{ 'TOTAL-REGISTERS' | translate }}:
                {{tt.totalRecords}} {{'OF' | translate}} {{usersTable.length}}
            </span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th [pSortableColumn]="'userId'" style="width: 5%">
                    {{'USER-ID' | translate}}
                    <p-sortIcon [field]="'userId'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'name'" style="width: 15%">
                    {{'NAME' | translate}}
                    <p-sortIcon [field]="'name'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'email'" style="width: 15%">
                    {{'EMAIL' | translate}}
                    <p-sortIcon [field]="'email'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'username'" style="width: 10%">
                    {{'USERNAME' | translate}}
                    <p-sortIcon [field]="'username'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'platform'" style="width: 8%">
                    {{'PLATFORM' | translate}}
                    <p-sortIcon [field]="'platform'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'platformVersion'" style="width: 7%">
                    {{'PLATFORM-VERSION' | translate}}
                    <p-sortIcon [field]="'platformVersion'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'loginDate'" style="width: 10%">
                    {{'LAST-LOGIN' | translate}}
                    <p-sortIcon [field]="'loginDate'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'applicationVersion'" style="width: 7%">
                    {{'APP-VERSION' | translate}}
                    <p-sortIcon [field]="'applicationVersion'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'created'" style="width: 10%">
                    {{'CREATED' | translate}}
                    <p-sortIcon [field]="'created'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'userActive'" style="width: 6%">
                    {{'USER-STATUS' | translate}}
                    <p-sortIcon [field]="'userActive'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'customerActive'" style="width: 7%">
                    {{'CUSTOMER-STATUS' | translate}}
                    <p-sortIcon [field]="'customerActive'"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
            <tr>
                <td>{{user.userId}}</td>
                <td>{{user.name}}</td>
                <td>{{user.email}}</td>
                <td>{{user.username}}</td>
                <td>{{user.platform}}</td>
                <td class="text-center">{{user.platformVersion}}</td>
                <td>{{user.loginDate | date: 'dd/MM/yyyy HH:mm'}}</td>
                <td class="text-center">{{user.applicationVersion}}</td>
                <td>{{user.created | date: 'dd/MM/yyyy HH:mm'}}</td>
                <td class="text-center">
                    <span *ngIf="user.userActive" class="badge badge-pill success">{{ 'ACTIVE' |
                            translate }}</span>
                    <span *ngIf="!user.userActive" class="badge badge-pill danger">{{ 'INACTIVE' |
                            translate }}</span>
                </td>
                <td class="text-center">
                    <span *ngIf="user.customerActive" class="badge badge-pill success">{{ 'ACTIVE' |
                            translate }}</span>
                    <span *ngIf="!user.customerActive" class="badge badge-pill danger">{{ 'INACTIVE' |
                            translate }}</span>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
